import { Box, styled } from '@mui/material';

const PREFIX = 'TSMED-Searchbar';

export const searchbarClasses = {
  root: `${PREFIX}-root`,
  icon: `${PREFIX}-icon`,
  input: `${PREFIX}-input`,
  button: `${PREFIX}-button`,
  dropdown: `${PREFIX}-dropdown`,
  result: `${PREFIX}-result`,
  resultLabel: `${PREFIX}-resultLabel`,
  resultSecondary: `${PREFIX}-resultSecondary`,
  divider: `${PREFIX}-divider`,
};

export const SearchbarStyled = styled(Box, {
  shouldForwardProp: prop =>
    prop !== 'isSmallDevice' && prop !== 'isCollapsed' && prop !== 'isPortrait',
})<{
  isSmallDevice: boolean;
  isCollapsed: boolean;
  isPortrait: boolean;
}>(
  ({
    theme: { spacing, palette, breakpoints, shadows, utils },
    isSmallDevice,
    isCollapsed,
  }) => ({
    position: 'relative',
    [`&.${searchbarClasses.root}`]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: palette.mapBlue[700],
      border: `2px solid ${palette.mapBlue[600]}`,
      borderRadius: spacing(1.5),
      height: spacing(5),
      width: isCollapsed ? spacing(5) : spacing(50),
      transition: 'width 0.3s ease',
      paddingLeft: 5,

      [breakpoints.down('md')]: {
        height: spacing(4),
        width: isCollapsed ? spacing(4) : spacing(40),
      },

      [breakpoints.down('xs')]: {
        width: isSmallDevice && isCollapsed ? spacing(4) : spacing(25),
        paddingLeft: 0,
      },
    },
    [`& .${searchbarClasses.icon}`]: {
      color: palette.common.white,
      height: 18,
      cursor: 'pointer',
    },

    [`& .${searchbarClasses.input}`]: {
      marginLeft: isSmallDevice && !isCollapsed ? 0 : spacing(0.5),
      flex: 1,
      color: palette.common.white,
      fontSize: '16px',
      fontFamily: 'Inter',
      fontWeight: 500,

      '& input::placeholder': {
        color: palette.grey[200],
        opacity: 1,
      },
    },

    [`& .${searchbarClasses.divider}`]: {
      width: '2px',
      height: '100%',
      backgroundColor: palette.mapBlue[600],
      margin: `0 ${spacing(1)}px`,
    },

    [`& .${searchbarClasses.button}`]: {
      color: palette.common.white,
      width: spacing(6),

      [breakpoints.down('xl')]: {
        width: spacing(5),
      },
    },

    [`& .${searchbarClasses.dropdown}`]: {
      padding: spacing(1),
      position: 'absolute',
      top: spacing(5.5),
      left: 0,
      width: '100%',
      scrollbarWidth: 'thin',
      scrollbarColor: `${palette.mapBlue[600]} transparent`,
      backgroundColor: palette.mapBlue[700],
      border: `2px solid ${palette.mapBlue[600]}`,
      borderRadius: spacing(1.5),
      zIndex: 1200,
      boxShadow: shadows[4],
      maxHeight: spacing(50),
      overflowY: 'auto',

      [breakpoints.down('md')]: {
        top: spacing(4.5),
      },

      '@media (max-height:500px)': {
        maxHeight: spacing(40),
      },

      '@media (max-height:400px)': {
        maxHeight: spacing(35),
      },
    },

    [`& .${searchbarClasses.result}`]: {
      padding: `${spacing(1)} ${spacing(2)}`,
      color: palette.common.white,
      borderRadius: spacing(1.5),
      cursor: 'pointer',
      display: 'grid',
      gridTemplateRows: 'auto auto',
      rowGap: 2,
      '&:hover': { backgroundColor: palette.mapBlue[800] },
    },
    [`& .${searchbarClasses.resultLabel}`]: {
      fontFamily: 'Inter',
      fontWeight: 600,
      lineHeight: 1.2,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    [`& .${searchbarClasses.resultSecondary}`]: {
      fontFamily: 'JetBrains Mono, monospace',
      fontSize: utils.clamp(14, 16),
      color: palette.grey[200],
      opacity: 0.9,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  }),
);
